module.exports = new __parcel__URL__("sprint-planning.32ed1a38.svg").toString();